const PROFILE_CACHE_KEY = 'tcode_profile'
const PROFILE_CACHE_TTL = 10 * 60 * 1000 // 10 минут

export function getCachedProfile() {
    try {
        const raw = localStorage.getItem(PROFILE_CACHE_KEY)
        if (!raw) return null
        const parsed = JSON.parse(raw)
        if (!parsed._time || Date.now() - parsed._time > PROFILE_CACHE_TTL) return null
        return parsed
    } catch (e) {
        return null
    }
}

export function cacheProfile(data) {
    try {
        localStorage.setItem(PROFILE_CACHE_KEY, JSON.stringify({ ...data, _time: Date.now() }))
    } catch (e) {
        // ignore
    }
}

export function clearProfileCache() {
    try {
        localStorage.removeItem(PROFILE_CACHE_KEY)
    } catch (e) {
        // ignore
    }
}